export const types = {
    ASSIGN: 'ASSIGN',
    LENGTH: 'LENGTH',
    LOWERCASE: 'LOWERCASE',
    UPPERCASE: 'UPPERCASE',
    SUBSTRING: 'SUBSTRING',
    SPLIT: 'SPLIT',
    REPLACE: 'REPLACE',
    SEARCH: 'SEARCH',
    TRIM: 'TRIM',
    CONVERTNUMBER: 'CONVERT-TO-NUMBER',
    CONVERTDATE: 'CONVERT-STRING-TO-DATE',
    CAPITALIZE: 'CAPITALIZE',
    PREPEND: 'PREPEND',
    APPEND: 'APPEND',
    REGEX: 'REGEX'
};